import *  as axios from 'axios';
import * as R from 'ramda';
import * as PartnerActionTypes from '../../constants/actiontypes/partner/partner';
import * as PartnerUrl from '../../constants/webapi/partner/partner';
import { getAuthenticationUrl } from '../../constants/webapi/auth';
import * as ActionTypesBO from '../../constants/actiontypes/backoffice/user';

import * as ActionTypesClients from '../../constants/actiontypes/backoffice/clients';
import * as ActionTypesAuth from '../../constants/actiontypes/auth';
import * as authUrls from '../../constants/webapi/auth';
import * as userUrls from '../../constants/webapi/user';


export function GetPartnerById(partnerId) {
	return (dispatch) => {
		dispatch({ type: PartnerActionTypes.FETCH_PARTNER_REQUEST });
		return axios.get(PartnerUrl.partnerByIdUrl(partnerId))
			.then((response) => {
				dispatch({
					type: PartnerActionTypes.FETCH_PARTNER_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnerActionTypes.FETCH_PARTNER_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function GetEtablissementsByPartnerId(partnerId) {
	return (dispatch) => {
		dispatch({ type: PartnerActionTypes.FETCH_ETABLISSEMENT_LIST_REQUEST });
		return axios.get(PartnerUrl.etablissementByPartnerIdUrl(partnerId))
			.then((response) => {
				dispatch({
					type: PartnerActionTypes.FETCH_ETABLISSEMENT_LIST_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnerActionTypes.FETCH_ETABLISSEMENT_LIST_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function GetPartnerLogo(partnerId) {
	return axios.get(PartnerUrl.partnerLogoByIdUrl(partnerId), { responseType: "arraybuffer" })
		.then((response) => {
			return `data:${response.headers['content-type']};base64,${new Buffer(response.data).toString('base64')}`;
		})
		.catch((error) => {
			if (error.response !== undefined) {
				if (error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				if (error.response.status === 404) {
					return;
				}
			}
			throw error;
		});
}

export function GetEtablissementById(partnerId, etablissementId) {
	return (dispatch) => {
		dispatch({ type: PartnerActionTypes.FETCH_ETABLISSEMENT_REQUEST });
		return axios.get(PartnerUrl.etablissementByIdAndPartnerIdUrl(partnerId, etablissementId))
			.then((response) => {
				dispatch({
					type: PartnerActionTypes.FETCH_ETABLISSEMENT_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnerActionTypes.FETCH_ETABLISSEMENT_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function GetUsersByPartnerIdAndEtablissementId(partnerId, etablissementId, pageNumber, searchTerm, type, startDate, endDate, sortByTerm, sortDesc) {
	const page = parseInt(pageNumber);
	if (!R.isNil(pageNumber) && isNaN(page)) {
		throw new Error("pageNumber must be null or an integer");
	}

	pageNumber = R.isNil(pageNumber) ? 0 : pageNumber - 1;

	return (dispatch) => {
		dispatch({ type: PartnerActionTypes.FETCH_USERS_REQUEST });
		return axios.get(PartnerUrl.usersByPartnerIdUrl(partnerId, etablissementId, pageNumber, searchTerm, type, startDate, endDate, sortByTerm, sortDesc))
			.then((response) => {
				dispatch({
					type: PartnerActionTypes.FETCH_USERS_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnerActionTypes.FETCH_USERS_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}


export function GetUsersByPartnerIdAndEtablissementIdDefaultAnticipa(partnerId, etablissementId, type, pageSize) {

	return (dispatch) => {
		dispatch({ type: PartnerActionTypes.FETCH_ANTICIPA_REQUEST });
		return axios.get(PartnerUrl.usersByPartnerIdUrlDefault(partnerId, etablissementId, type, pageSize))
			.then((response) => {
				dispatch({
					type: PartnerActionTypes.FETCH_ANTICIPA_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnerActionTypes.FETCH_ANTICIPA_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function GetUsersByPartnerIdAndEtablissementIdDefaultFacilita(partnerId, etablissementId, type, pageSize) {

	return (dispatch) => {
		dispatch({ type: PartnerActionTypes.FETCH_FACILITA_REQUEST });
		return axios.get(PartnerUrl.usersByPartnerIdUrlDefault(partnerId, etablissementId, type, pageSize))
			.then((response) => {
				dispatch({
					type: PartnerActionTypes.FETCH_FACILITA_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnerActionTypes.FETCH_FACILITA_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function GetUsersByPartnerIdAndEtablissementIdDefaultSerenita(partnerId, etablissementId, type, pageSize) {

	return (dispatch) => {
		dispatch({ type: PartnerActionTypes.FETCH_SERENITA_REQUEST });
		return axios.get(PartnerUrl.usersByPartnerIdUrlDefault(partnerId, etablissementId, type, pageSize))
			.then((response) => {
				dispatch({
					type: PartnerActionTypes.FETCH_SERENITA_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnerActionTypes.FETCH_SERENITA_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function GetUsersByPartnerIdAndEtablissementIdDefault(partnerId, etablissementId, type, pageSize) {
	return new Promise((resolve, reject) => {
		axios.get(PartnerUrl.usersByPartnerIdUrlDefault(partnerId, etablissementId, type, pageSize))
			.then((response) => {
				resolve(response.data);
			})
			.catch((error) => {
				reject(error);
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				throw error;
			});
	});
}

export function CreateUsersByPartnerId(partnerId, userDto) {
	return (dispatch) => {
		dispatch({ type: PartnerActionTypes.CREATE_USER_REQUEST });
		return axios.post(PartnerUrl.createUserByPartnerIdUrl(partnerId), userDto)
			.then((response) => {
				dispatch({
					type: PartnerActionTypes.CREATE_USER_SUCCESS,
					data: response.data
				});
				return response.data;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnerActionTypes.CREATE_USER_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function AddUserAddress(userId, addressDto) {
	return axios.post(PartnerUrl.userAddressByIdUrl(userId), addressDto)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}
			throw error.statusText;
		});
}

export function AddReferentToUserId(userId, referentDto) {
	return axios.post(PartnerUrl.userRepresentativesUrl(), { ...referentDto, userId: userId })
		.then((response) => {
			return response;
		})
		.catch((error) => {
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}
			throw error.statusText;
		});
}

export function SendUserActivationEmailByPartnerId(userId, partnerId, role) {
	return axios.put(PartnerUrl.userSendActivationEmailByIdPartnerIdUrl(partnerId, userId, role))
		.then((response) => {
			return;
		})
		.catch((error) => {
			throw error;
		});
}

export function GetEtablissementInvoicesToPay(etablissementId) {
	return axios.get(PartnerUrl.etablissementInvoicesToPay(etablissementId))
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}
			throw error;
		});
}

export function GetEtablissementInvoicesToBill(etablissementId) {
	return axios.get(PartnerUrl.etablissementInvoicesToBill(etablissementId))
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}
			throw error;
		});
}

export function GetPartnerInvoicesToPay(partnerId) {
	return axios.get(PartnerUrl.partnerInvoicesToPay(partnerId))
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}
			throw error;
		});
}

export function GetPartnerInvoicesToBill(partnerId) {
	return axios.get(PartnerUrl.partnerInvoicesToBill(partnerId))
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}
			throw error;
		});
}


export function GetInvoiceLines(invoiceId) {
	return axios.get(PartnerUrl.invoiceLinesByInvoiceId(invoiceId))
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}
			throw error;
		});
}

export function resetPassword(email, phoneNumber) {
	return (dispatch) => {
		dispatch({ type: ActionTypesAuth.RESET_PASSWORD_REQUEST });
		return axios.post(authUrls.resetPasswordEmail(), { email, phoneNumber })
			.then(() => {
				dispatch({
					type: ActionTypesAuth.RESET_PASSWORD_SUCCESS
				});
			})
			.catch((error) => {
				dispatch({
					type: ActionTypesAuth.RESET_PASSWORD_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function updateUserSecurity(userId, user) {
	return (dispatch) => {
		dispatch({ type: ActionTypesClients.UPDATE_CLIENT_SECURITY_REQUEST, user: userId });
		return axios.put(userUrls.userSecurityByIdUrl(userId), user)
			.then((response) => {
				dispatch({
					type: ActionTypesClients.UPDATE_CLIENT_SECURITY_SUCCESS,
					data: response.data,
					user: user,
					userId: userId
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypesClients.UPDATE_CLIENT_SECURITY_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function closeDossier(userId, user) {
	return (dispatch) => {
		dispatch({ type: ActionTypesBO.DELETE_BACKOFFICE_USER_REQUEST, user: userId });

		return axios.delete(userUrls.userSoftDeleteByIdUrl(userId), user)
			.then(() => {
				dispatch({
					type: ActionTypesBO.DELETE_BACKOFFICE_USER_SUCCESS,
					user: user,
					userId: userId
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypesBO.DELETE_BACKOFFICE_USER_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
};

export function payUserInvoice(invoiceId) {
	return (dispatch) => {
		dispatch({ type: PartnerActionTypes.PAY_USER_INVOICE_REQUEST, invoiceId: invoiceId });

		return axios.put(PartnerUrl.payInvoiceByIdUrl(invoiceId))
			.then(() => {
				dispatch({
					type: PartnerActionTypes.PAY_USER_INVOICE_SUCCESS,
					invoiceId: invoiceId
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnerActionTypes.PAY_USER_INVOICE_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
};

export function fetchInvoices(userId) {
	return axios.get(userUrls.getRecipientInvoicesByIdUrl(userId))
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			throw error.statusText;
		});
}